/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appGitlab_viewer$ref = any;
export type appGitlab_QueryVariables = {||};
export type appGitlab_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appGitlab_viewer$ref,
  |}
|};
export type appGitlab_Query = {|
  variables: appGitlab_QueryVariables,
  response: appGitlab_QueryResponse,
|};
*/


/*
query appGitlab_Query {
  viewer {
    actualPersonId
    component(name: "app_gitlab")
    ...appGitlab_viewer
    id
  }
}

fragment appGitlab_viewer on Viewer {
  id
  company {
    id
    gitlabEnabled
    gitlabServerEnabled
    gitlabServerUrl
    gitlabServerToken
    gitlabDeleteIssues
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_gitlab"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_gitlab\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appGitlab_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appGitlab_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appGitlab_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabDeleteIssues",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appGitlab_Query",
    "operationKind": "query",
    "text": "query appGitlab_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_gitlab\")\n    ...appGitlab_viewer\n    id\n  }\n}\n\nfragment appGitlab_viewer on Viewer {\n  id\n  company {\n    id\n    gitlabEnabled\n    gitlabServerEnabled\n    gitlabServerUrl\n    gitlabServerToken\n    gitlabDeleteIssues\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6b4c8dc10fc748be4948546a9a1c2a34';

module.exports = node;
